
import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

interface TimeRangeSelectorProps {
  timeRange: string;
  setTimeRange: (value: string) => void;
  timeRanges: Record<string, { label: string; days: number }>;
}

const TimeRangeSelector: React.FC<TimeRangeSelectorProps> = ({ 
  timeRange, 
  setTimeRange, 
  timeRanges 
}) => {
  return (
    <div className="flex items-center">
      <Select value={timeRange} onValueChange={setTimeRange}>
        <SelectTrigger className="w-[150px]">
          <SelectValue placeholder="Select time range" />
        </SelectTrigger>
        <SelectContent>
          {Object.entries(timeRanges).map(([key, { label }]) => (
            <SelectItem key={key} value={key}>{label}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default TimeRangeSelector;
